import { render, staticRenderFns } from "./DrawerNavigationDesktop.vue?vue&type=template&id=a7a5fff4&scoped=true&"
import script from "./DrawerNavigationDesktop.vue?vue&type=script&lang=js&"
export * from "./DrawerNavigationDesktop.vue?vue&type=script&lang=js&"
import style0 from "./DrawerNavigationDesktop.vue?vue&type=style&index=0&id=a7a5fff4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a5fff4",
  null
  
)

export default component.exports